class CountdownTimer extends HTMLElement {
  connectedCallback() {
    this.updateDisplay();
    this.interval = setInterval(() => this.updateDisplay(), 1000);
  }

  disconnectedCallback() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  updateDisplay() {
    const endDate = new Date(this.getAttribute('end-date')).getTime();
    const now = new Date().getTime();
    const diff = endDate - now;

    if (diff < 0) {
      this.innerHTML = '';
      if (this.interval) clearInterval(this.interval);
      return;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    this.querySelectorAll('[data-value="days"]').forEach(el => {
      el.textContent = String(days).padStart(2, '0');
    });
    this.querySelectorAll('[data-value="hours"]').forEach(el => {
      el.textContent = String(hours).padStart(2, '0');
    });
    this.querySelectorAll('[data-value="minutes"]').forEach(el => {
      el.textContent = String(minutes).padStart(2, '0');
    });
    this.querySelectorAll('[data-value="seconds"]').forEach(el => {
      el.textContent = String(seconds).padStart(2, '0');
    });
  }
}

customElements.define('countdown-timer', CountdownTimer);
